module.exports = __webpack_public_path__ + "static/media/mob-conan-windetails.e70332c7.jpg";